export default {
  translations: {
    logo: 'حسابي',
    user: {
      you: 'أنت',
    },

    generic: {
      entities: {
        accountGroup: 'مجموعة الحسابات',
        account: 'حساب',
        accountPermission: 'صلاحية',
        accountTransaction: 'حركة مالية',
        check: 'شيك',
      },
      messages: {
        welcome: 'أهلا بك',
        loadingPleaseWait: 'يرجى الإنتظار...',
        noDataFound: 'لا توجد بيانات',
        success: 'تمت العملية بنجاح',
      },
      words: {
        others: 'اخرى',
        currency: 'العملة',
      },
      errors: {
        dataIncomplete:
          'حدث خلل.. .البيانات غير مكتملة.. يرجى التأكد من اتصالك في الانترنت',
        operationFailed: 'لم تتم العملية بنجاح!',
        pageNotFound: 'عذراً...  الصفحة المطلوبة غير موجودة',
        internalError:
          'عذرأ...  حدث عطل فني في الصفحة وجاري العمل على إصلاحه... يرجى المحاولة لاحقا',
      },
      links: {
        goToLogin: 'تسجيل الدخول',
        goToHomePage: 'اذهب الى الصفحة الرئيسة',
        logout: 'تسجيل الخروج',
        enableNotifications: 'تفعيل الإشعارات',
        notificationsEnabled: 'الإشعارات مفعلة',
        notificationsBlocked: 'الإشعارات محظورة',
        notificationsUnsupported: 'الإشعارات غير مدعومة',
      },
      actions: {
        cancel: 'الغاء',
        save: 'حفظ',
        delete: 'حذف',
        criticalDelete: 'نعم، أفهم ذلك. أحذف!',
        yes: 'نعم',
        no: 'لا',
        ok: 'تم',
        export: 'تنزيل',
      },
    },

    dashboard: {
      title: 'الرئيسية',
      sharedWithMeGroup: 'حسابات تم مشاركتها معي',
    },

    accountGroup: {
      actions: {
        add: 'أضف مجموعة حسابات',
        edit: 'تعديل مجموعة الحسابات',
        delete: 'حذف محموعة الحسابات',
        showArchived: 'الارشيف',
      },
      form: {
        title: {
          edit: 'تعديل مجموعة الحسابات',
          create: 'مجموعة حسابات جديدة',
        },
        inputAccountGroupName: 'إسم المجموعة',
        inputAccountGroupArchived: 'الارشيف',
        archivedWarning: {
          title: 'الأرشيف',
          body: 'عند حفظ مجموعة الحسابات في الأرشيف ستختفي تلقائيا من القائمة في الصفحة الرئسية (لكن لن يخذف أي شيء).. يمكنك دوما رؤية المجموعات المحفوظة في الأرشيف او اعادتها',
        },
      },
      deleteForm: {
        title: 'حذف مجموعة الحسابات',
        body: 'هل انت متأكد أنك تريد حذف المجموعة؟ جميع الحسابات داخل هذه المجموعة (بما فيها الأرشيف) سيتم حذفها، بالاضافة الى جميع الحركات على تلك الحسابات',
      },
    },

    account: {
      attributes: {
        name: 'اسم الحساب',
        lastTransaction: 'اخر حركة',
      },
      actions: {
        add: 'أضف حساب',
        edit: 'تعديل الحساب',
        delete: 'حذف الحساب',
      },
      card: {
        owner: 'المالك',
        on: 'في',
        noActivities: 'لا يوجد حركات',
        stats: 'نسب المشاركة',
        permissions: 'قائمة الأعضاء',
        debits: 'ديون',
        participation: 'مشاركة',
      },
      form: {
        title: {
          edit: 'تعديل الحساب',
          create: 'حساب جديد',
        },
        selectGroupName: 'إختر المجموعة التي تريد اضافة الحساب اليها',
        selectCurrency: 'إختر العملة',
        inputAccountName: 'أدخل اسم الحساب',
        permissionsSectionHeader: 'إعدادات المشاركة',
        archivedWarning: {
          title: 'الأرشيف',
          body: 'عند حفظ الحساب في الأرشيف سيختفي تلقائيا من قائمة الحسابات في الصفحة الرئسية (لكن لن يخذف أي شيء).. يمكنك دوما رؤية الحسابات المحفوظة في الأرشيف او اعادتها',
        },
      },
      deleteForm: {
        title: 'حذف الحساب',
        body: 'هل انت متأكد أنك تريد حذف الحساب؟ جميع الحركات المالية على هذا الحساب سيتم حذفها أيضا',
      },
      currency: {
        NIS: 'شيكل',
        USD: 'دولار',
        EURO: 'يورو',
        JOD: 'دينار',
      },
    },

    accountPermission: {
      form: {
        selectUser: 'اختر أشخاص لمشاركة الحساب معهم',
        userNameColumn: 'الاسم',
        canEditColumn: 'صلاحية الإضافة',
        explanation: {
          title: 'الحساب المشترك:',
          body: 'جميع الأشخاص في هذه القائمة يمكنهم رؤية الحساب والحركات المالية عليه. لكن، فقظ الأشخاص الذين تم تفعيل "صلاحية الإضافة" لهم يمكنهم اضافة حركات مالية للحساب.',
        },
      },
      list: {
        title: 'المشتركين في الحساب',
      },
    },

    transaction: {
      actions: {
        add: 'أضف حركة مالية',
        edit: 'تعديل الحركة المالية',
        delete: 'حذف الحركة المالية',
        filter: 'ابحث',
        resetFilters: 'ازالة الفلاتر',
      },
      form: {
        title: {
          edit: 'تعدل الحركة المالية',
          create: 'حركة مالية جديدة',
        },
        inputAmount: 'ادخل المبلغ',
        inputDescription: 'ملاحظات...',
        selectDate: 'اختر تاريخ الحركة',
        inputTags: 'التصنيفات',
      },
      list: {
        filteredBalance: 'مجموع الحركات ضمن الفلتر',
      },
      filters: {
        startDate: 'تاريخ البداية',
        endDate: 'تاريخ النهاية',
        tags: 'التصنيفات',
        transactionType: 'نوع العملية',
        fromCheck: 'من شيك',
      },
      deleteForm: {
        title: 'حذف الحركة المالية',
        body: 'هل تريد حذف هذه الحركة؟',
      },
      operation: {
        added: 'اضاف',
        withdrew: 'سحب',
        deposit: 'أضافة',
        withdraw: 'سحب',
      },
      transactionTypes: {
        credit: 'أضافة',
        debit: 'سحب',
      },
      words: {
        transactionType: 'نوع العملية',
        date: 'تاريخ العملية',
        amount: 'المبلغ',
        description: 'ملاحظاث',
        filters: 'فلتر',
      },
    },

    check: {
      title: 'الشيكات',
      actions: {
        add: 'أضف شيك',
        edit: 'تعديل الشيك',
        delete: 'حذف الشيك',
        filter: 'ابحث',
        resetFilters: 'ازالة الفلاتر',
      },
      form: {
        title: {
          edit: 'تعدل الشيك',
          create: 'شيك جديد',
        },
        inputAmount: 'ادخل المبلغ',
        inputDescription: 'ملاحظات...',
        selectDate: 'اختر تاريخ الحركة',
        selectFromAccount: 'اختر حساب المصدر',
        selectToAccount: 'اختر حساب الوجهة',
        inputTags: 'التصنيفات',
      },
      list: {
        filteredBalances: 'مجموع الشيكات ضمن الفلتر',
        totalBalances: 'مجموع الشيكات',
      },
      filters: {
        startDate: 'تاريخ البداية',
        endDate: 'تاريخ النهاية',
        tags: 'التصنيفات',
        status: 'حالة الشيك',
        fromAccount: 'من حساب',
        toAccount: 'الى حساب',
        enforceTagsIntersection: 'يجب ان تشمل جميع التصنيفات',
      },
      deleteForm: {
        title: 'حذف الشيك',
        body: 'هل تريد حذف هذه الشيك (والحركات المالية المرتبطة به)؟',
      },
      checkStatuses: {
        pending: 'مستقبلي',
        applied: 'مسحوب',
      },
      words: {
        checkStatus: 'حالة الشيك',
        date: 'تاريخ العملية',
        amount: 'المبلغ',
        description: 'ملاحظاث',
        filters: 'فلتر',
        fromAccount: 'من حساب',
        toAccount: 'الى حساب',
      },
    },

    stats: {
      negativeOrZeroBalances:
        'المجموع الكلي للحسابات صفر او أقل.. الرسم البياني غير ممكن!',
      selectAccountsPlaceholder: 'اختر الحسابات',
      totalBalance: 'المجموع الكلي',
      conversionApiIsDown:
        'خدمة تحويل العملات لا تعمل حاليا... الأرقام أدناه قد تكون غير صحيحة... يرجى المحاولة لاحقا',
    },
  },
};
